export const EventTypes = [
  { _id: 'communityPresentations', name: 'Community Presentations' },
  { _id: 'employerConnections', name: 'Employer Connections' },
  { _id: 'employerVisits', name: 'Employer Visits' },
  { _id: 'fair', name: 'Fair' },
];
